import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function CastConnectedIcon(props: IconProps) {
    return <Icon {...props} iconKey={"cast_connected"}/>
}
